export default {
  title: "Cuenta",
  subtitle: "Gestiona la información de tu cuenta",
  description: "Gestiona la configuración de tu cuenta",
  profileSettings: "Configuración del perfil",
  accountSettings: "Configuración de la cuenta",
  personalInfo: "Información personal",
  dataManagement: "Gestión de datos",
  privacySettings: "Configuración de privacidad",
  profile: {
    title: "Perfil",
    completeProfile: "Completar perfil",
    defaultName: "Invitado",
    noProfile: "Sin perfil",
    errors: {
      loadProfile: "Error al cargar el perfil",
      saveProfile: "Error al guardar el perfil"
    },
    weddingInfo: {
      title: "Información de la boda",
      partner1: "Pareja 1",
      partner2: "Pareja 2",
      date: "Fecha",
      location: "Lugar",
      expectedGuests: "Invitados esperados",
      notes: "Notas"
    }
  },
  settings: {
    title: "Configuración",
    loadError: "Error al cargar la configuración",
    saveError: "Error al guardar la configuración",
    saveSuccess: "Configuración guardada exitosamente"
  },
  security: "Seguridad",
  notifications: "Notificaciones",
  profilePhoto: "Foto de perfil",
  changePhoto: "Cambiar foto",
  photoRequirements: "JPG, PNG o GIF, 2MB máx",
  deletePhoto: "Eliminar foto",
  saveChanges: "Guardar cambios",
  twoFactorAuth: "Autenticación de dos factores",
  linkedAccounts: "Cuentas vinculadas",
  dataExport: "Exportar datos",
  subscription: {
    title: "Suscripción",
    currentPlan: "Plan actual",
    free: "Gratuito",
    essential: "Esencial",
    pro: "Pro",
    manage: "Gestionar suscripción",
    viewPlans: "Ver planes",
    upgrade: "Mejorar plan",
    eventsUsed: "Eventos utilizados",
    limits: {
      maxGuests: "Invitados máx",
      maxTasks: "Tareas máx",
      maxVendors: "Proveedores máx",
      maxEvents: "Eventos máx"
    },
    features: {
      unlimitedEvents: "Eventos ilimitados",
      unlimitedGuests: "Invitados ilimitados",
      export: "Exportación PDF y Excel",
      budget: "Presupuesto y Análisis",
      seating: "Plan de asientos",
      support: "Soporte prioritario"
    },
    plans: {
      free: {
        name: "Gratuito"
      },
      essential: {
        name: "Esencial"
      },
      premium: {
        name: "Premium"
      },
      pro: {
        name: "Pro"
      }
    }
  },
  limits: {
    title: "Límites",
    maxGuests: "Máximo de invitados",
    maxTasks: "Máximo de tareas",
    maxVendors: "Máximo de proveedores",
    maxCollaborators: "Máximo de colaboradores"
  },
  form: {
    firstName: "Nombre",
    lastName: "Apellido",
    email: "Correo electrónico",
    phone: "Teléfono",
    address: "Dirección",
    city: "Ciudad",
    country: "País",
    timezone: "Zona horaria",
    language: "Idioma",
    avatar: "Avatar"
  },
  actions: {
    save: "Guardar",
    cancel: "Cancelar",
    edit: "Editar",
    delete: "Eliminar cuenta",
    changePassword: "Cambiar contraseña",
    uploadAvatar: "Subir avatar"
  },
  messages: {
    profileUpdated: "Perfil actualizado exitosamente",
    passwordChanged: "Contraseña cambiada exitosamente",
    avatarUploaded: "Avatar subido exitosamente",
    accountDeleted: "Cuenta eliminada exitosamente",
    error: "Ocurrió un error"
  },
  events: {
    yourEvents: "Tus eventos"
  },
  partners: {
    title: "Información de la pareja",
    partner1: "Pareja 1",
    partner2: "Pareja 2",
    firstName: "Nombre",
    lastName: "Apellido",
    email: "Correo electrónico",
    save: "Guardar"
  },
  pageTitle: "Cuenta | WedBox",
  accountManagement: "Gestión de cuenta",
  chooseWhatToManage: "Elige qué quieres gestionar",
  myProfile: "Mi Perfil",
  personalPreferences: "Preferencias personales",
  managePersonalInfo: "Gestiona tu información personal, foto de perfil, idioma y preferencias de notificación.",
  accessMyProfile: "Acceder a mi perfil",
  eventSettings: "Configuración del evento",
  eventTypeSpecific: {
    wedding: {
      subtitle: "Específico para tu boda",
      description: "Gestiona los detalles de tu boda, parejas, fecha, colaboradores y estadísticas.",
      buttonText: "Configuración de boda"
    },
    birthday: {
      subtitle: "Específico para tu cumpleaños",
      description: "Gestiona los detalles de tu cumpleaños, fecha, colaboradores y estadísticas.",
      buttonText: "Configuración de cumpleaños"
    },
    "baby-shower": {
      subtitle: "Específico para tu baby shower",
      description: "Gestiona los detalles de tu baby shower, fecha, colaboradores y estadísticas.",
      buttonText: "Configuración de baby shower"
    },
    baptism: {
      subtitle: "Específico para tu bautismo",
      description: "Gestiona los detalles de tu bautismo, fecha, colaboradores y estadísticas.",
      buttonText: "Configuración de bautismo"
    },
    engagement: {
      subtitle: "Específico para tu compromiso",
      description: "Gestiona los detalles de tu compromiso, fecha, colaboradores y estadísticas.",
      buttonText: "Configuración de compromiso"
    },
    default: {
      subtitle: "Específico para tu evento",
      description: "Gestiona los detalles de tu evento, fecha, colaboradores y estadísticas.",
      buttonText: "Configuración del evento"
    }
  },
  improvedOrganization: "📋 Organización mejorada",
  organizationNote: "Hemos separado la configuración personal de la configuración específica del evento para una mejor organización. Tus preferencias de usuario están ahora en \"Mi Perfil\", mientras que todo lo relacionado con tu evento se encuentra en \"Configuración del evento\".",
  subscriptionManagement: "Gestión de suscripciones",
  manageYourPlan: "Gestiona tu plan y sigue tu uso",
  displayName: "Nombre para mostrar",
  phoneNumber: "Número de teléfono",
  yourFullName: "Tu nombre completo",
  emailAddress: "Dirección de correo electrónico",
  emailCannotBeModified: "El correo electrónico no puede modificarse por razones de seguridad",
  personalInformation: "Información personal",
  languageInterface: "Idioma de la interfaz",
  notificationPreferences: "Preferencias de notificación",
  emailNotifications: "Notificaciones por correo",
  receiveEmailNotifications: "Recibir notificaciones por correo",
  pushNotifications: "Notificaciones push",
  receiveBrowserNotifications: "Recibir notificaciones en el navegador",
  deleteAccountWarning: "⚠️ Esta acción es irreversible. Todos tus datos serán eliminados permanentemente.",
  permanentlyDeleteAccount: "Eliminar permanentemente mi cuenta",
  languageChangedTo: "Idioma cambiado a {{language}}",
  error: "Error:",
  saveError: "Puedes agregar una notificación de error aquí",
  language: "Idioma",
  languageDescription: "Elige el idioma de visualización de la aplicación",
  languageSelect: "Selecciona tu idioma",
  weddingDetails: "Detalles de la boda",
  weddingDate: "Fecha de la boda",
  partnerInfo: "Información de la pareja",
  partner1: "Pareja 1",
  partner2: "Pareja 2",
  firstName: "Nombre",
  lastName: "Apellido",
  accessManagement: "Gestión de acceso",
  accessManagementDescription: "Gestiona quién puede acceder a los datos de tu boda",
  manageCollaborators: "Gestionar colaboradores",
  loadError: "Error al cargar la configuración",
  saveSuccess: "Configuración guardada exitosamente",
  noData: "No hay datos disponibles",
  tabs: {
    profile: "Perfil",
    sharing: "Compartir",
    settings: "Configuración"
  },
  delete: {
    title: "Eliminar cuenta",
    description: "Eliminar permanentemente tu cuenta y todos los datos asociados",
    confirmTitle: "¿Estás seguro?",
    confirmDescription: "Esta acción es irreversible. Todos tus datos serán eliminados permanentemente.",
    confirmButton: "Eliminar cuenta",
    gdprNotice: "De acuerdo con el RGPD, todos tus datos personales serán eliminados permanentemente."
  },
  deleteAccount: {
    title: "Eliminar cuenta",
    description: "Esta acción eliminará permanentemente tu cuenta y todos tus datos. Esta acción es irreversible.",
    warning: "Advertencia: Esta acción es irreversible y eliminará permanentemente todos tus datos.",
    confirm: "Sí, eliminar mi cuenta",
    confirmDescription: "Confirma tu contraseña para eliminar tu cuenta.",
    confirmFacebookDescription: "Estás conectado con Facebook. Para confirmar la eliminación de tu cuenta, haz clic en el botón de abajo.",
    confirmGoogleDescription: "Estás conectado con Google. Para confirmar la eliminación de tu cuenta, haz clic en el botón de abajo.",
    passwordLabel: "Contraseña",
    reasonLabel: "Razón de la eliminación",
    feedbackLabel: "Comentarios adicionales",
    reasons: {
      select: "Selecciona una razón",
      notUseful: "La aplicación no es útil para mí",
      tooComplex: "La aplicación es demasiado compleja",
      foundAlternative: "Encontré una mejor alternativa",
      other: "Otra razón"
    },
    errors: {
      invalidPassword: "Contraseña incorrecta",
      reasonRequired: "Por favor selecciona una razón",
      popupClosed: "La ventana de confirmación fue cerrada",
      authCancelled: "Autenticación cancelada",
      generic: "Ocurrió un error",
      recentLogin: "Por favor inicia sesión nuevamente para realizar esta acción",
      wrongPassword: "Contraseña incorrecta"
    },
    success: "Cuenta eliminada exitosamente"
  },
  export: {
    title: "Exportar datos",
    description: "Descarga todos tus datos en formato JSON",
    button: "Descargar datos",
    loading: "Preparando descarga...",
    gdprNotice: "Esta exportación incluye todos tus datos personales según los requisitos del RGPD."
  },
  errors: {
    deleteAccount: "Error al eliminar la cuenta",
    exportData: "Error al exportar los datos"
  },
  collaborators: {
    title: "Colaboradores",
    description: "Gestiona las personas que pueden ayudarte con la planificación de tu boda",
    count: "{{count}} colaboradores",
    invite: "Invitar colaborador",
    inviteEmail: "Dirección de correo electrónico",
    placeholder: "Ingresa la dirección de correo",
    manage: "Gestionar colaboradores",
    pending: "Invitaciones pendientes",
    active: "Colaboradores activos",
    role: "Rol",
    roles: {
      owner: "Propietario",
      admin: "Administrador",
      editor: "Editor",
      viewer: "Visor"
    },
    roleDescriptions: {
      admin: "Puede modificar todo y gestionar colaboradores",
      editor: "Puede modificar secciones seleccionadas",
      viewer: "Solo puede ver secciones seleccionadas"
    },
    rolesTitle: "Gestión de roles",
    accessTo: "Acceso a",
    accessToSections: "Acceso a secciones",
    resourceTypes: {
      all: "Todo",
      tasks: "Tareas",
      tasks_and_guests: "Tareas e invitados",
      guests: "Invitados",
      budget: "Presupuesto",
      timeline: "Cronograma"
    },
    status: {
      active: "Activo",
      pending: "Pendiente",
      expired: "Expirado",
      refused: "Rechazado",
      accepted: "Aceptado"
    },
    lastActive: "Última actividad",
    remove: "Eliminar colaborador",
    changeRole: "Cambiar rol",
    modifyAccess: "Modificar acceso",
    updateRoleError: "Error al actualizar el rol",
    inviteSuccess: "Invitación enviada exitosamente",
    inviteError: "Error al enviar la invitación",
    list: "Lista de colaboradores",
    empty: "Aún no hay colaboradores"
  },
  stats: {
    title: "Estadísticas",
    daysLeft: "{{count}} días restantes",
    noDate: "Ninguna fecha definida",
    weddingDate: "Fecha de la boda",
    progress: "Progreso",
    tasks: "Tareas",
    tasksCompleted: "{{completed}} de {{total}} tareas completadas",
    noTasksCompleted: "Ninguna tarea completada",
    allTasksCompleted: "Todas las tareas completadas",
    guests: "Invitados",
    guestsInvited: "{{count}} invitados invitados",
    noGuests: "Ningún invitado",
    married: "¡Están casados!",
    almostDone: "¡Casi terminado!",
    halfwayThere: "¡A mitad de camino!",
    keepGoing: "¡Sigue así!"
  },
  sharing: {
    activeLinksTitle: "Enlaces de intercambio activos",
    activeLinksDesc: "Estos enlaces permiten el acceso a su evento sin una cuenta de usuario.",
    accessTo: "Acceso a"
  }
};
